import React, { useCallback, useEffect } from 'react'
import HouseConsignmentsTableRow from './HouseConsignmentsTableRow'
import { HouseConsignment } from '../../house-consignment/models/types'

interface HouseConsignmentsProps {
  consignmentId: number
  houseConsignments: HouseConsignment[]
  consignmentConsignorName: string | null
  consignmentConsigneeName: string | null
  isLoading: boolean
}

function HouseConsignmentsTable({
  consignmentId,
  houseConsignments,
  consignmentConsignorName,
  consignmentConsigneeName,
  isLoading,
}: Readonly<HouseConsignmentsProps>) {
  const [expanded, setExpanded] = React.useState<Set<number>>(
    () => (houseConsignments.length < 2
      ? new Set(houseConsignments.map((h) => h.id))
      : new Set()),
  )

  useEffect(() => {
    if (!houseConsignments?.length) return
    setExpanded(houseConsignments.length < 2
      ? new Set(houseConsignments.map((h) => h.id))
      : new Set())
  }, [houseConsignments])

  const toggle = useCallback((id: number) => {
    setExpanded((prev) => {
      const next = new Set(prev)
      if (next.has(id)) {
        next.delete(id)
      } else {
        next.add(id)
      }
      return next
    })
  }, [])

  return (
    <div className="col-12 transit-sidebar__house-consignments">
      {!isLoading && houseConsignments.length > 0 && houseConsignments.map((house, houseIdx) => (
        <HouseConsignmentsTableRow
          key={house.id}
          houseSequenceNumber={houseIdx}
          houseConsignment={house}
          consignmentId={consignmentId}
          consignmentConsignorName={consignmentConsignorName}
          consignmentConsigneeName={consignmentConsigneeName}
          isExpanded={expanded.has(house.id)}
          onRowToggle={() => toggle(house.id)}
        />
      ))}
    </div>
  )
}

export default HouseConsignmentsTable
